import React from 'react';
import Nav from 'react-bootstrap/lib/Nav';
import Navbar from 'react-bootstrap/lib/Navbar';
import NavItem from 'react-bootstrap/lib/NavItem';
import NavLink from './NavLink';
import NAV_ITEM from '../../constantValues/NAV_ITEM_PROPERTIES';

const NavLogout = () => (
    <Navbar.Collapse>
        <Nav pullRight>
            <NavItem eventKey={NAV_ITEM.login.key}>
                <NavLink
                    path={NAV_ITEM.login.path}
                    name={NAV_ITEM.login.name}
                    className={NAV_ITEM.login.className}
                />
            </NavItem>
        </Nav>
    </Navbar.Collapse>
);

export default NavLogout;



// WEBPACK FOOTER //
// ./src/components/Navbar/NavLogout.js